<template>
  <div class="content-box">
    <div class="roleFiles">
      <div
        class="roleFiles-box red-bold"
        v-for="(role, roleIndex) in rolelist"
        :key="roleIndex"
        :class="{borderBot: roleIndex>0 && roleIndex%6==0}"
        @mouseout="departShow=-1"
      >
        <div class="roleFiles-number">[{{ role.Code }}]</div>
        <div class="roleFiles-title">
          <div
            class="roleFiles-title-content"
            v-if="role.ChildCount > 0"
            @click="showOrGo(role.ChildCount, roleIndex, role.Id)"
          >{{ role.Name }}</div>

          <div
            v-else-if="role.ChildCount  <= 0"
            class="roleFiles-title-content"
            @mouseover="departShow=roleIndex"
          >
            <router-link
              tag="a"
              :to="{path: '/homeInfo', query:{id: role.Id}}"
              target="_blank"
            >{{ role.Name }}</router-link>
            <div class="roleFiles-title-depart" v-show="departShow == roleIndex">
              <router-link
                tag="a"
                :to="{path: '/homeInfo', query:{id: role.Id}}"
                target="_blank"
              >责任科室:{{role.ImplementingAgency}}</router-link>
            </div>
          </div>
          <transition-group name="bounce" tag="div">
            <div
              class="roleFiles-childBox red-bold"
              v-for="child in role.ChildList"
              :key="child.Code"
              v-show="openList == roleIndex"
            >
              <div class="roleFiles-child-number">[{{ child.Code }}]</div>
              <div class="roleFiles-child-title">
                <router-link
                  tag="a"
                  :to="{path: '/homeInfo',query:{id: child.Id}}"
                  target="_blank"
                >{{ child.Name }}</router-link>
              </div>
              <!-- <div
                class="roleFiles-child-title"
                @click="showOrGo(-1, roleIndex, child.Id)"
              >{{ child.Name }}</div>-->
            </div>
          </transition-group>
        </div>
        <!-- <div class="roleFiles-hasChild">{{ role.ChildCount | childFilter }}</div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rolelist: {
      type: Array,
      default: function () {
        return [];
      },
      required: true,
    },
  },
  data() {
    return {
      openList: -1,
      departShow: -1,
      // childList: []
    };
  },
  methods: {
    showDepart() {},
    showOrGo(len, index, id) {
      if (len > 0) {
        if (this.openList == index) {
          this.openList = -1;
        } else {
          this.openList = index;
        }
        // this.rolelist[index].flag = !this.rolelist[index].flag;
        // this.$axios({
        //   url: "api/getChildListById/" + id,
        //   type: "get"
        // })
        //   .then(res => {
        //     this.childList = res.data.childList;
        //   })
        //   .catch(err => {
        //     console.info(err);
        //   });
      }
    },
  },
  filters: {
    childFilter(val) {
      if (val > 0) {
        return val + "项子项";
      } else {
        return "无子项";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-box {
  width: 100%;
  height: 100%;
  .roleFiles {
    width: 100%;
    height: auto;
    margin: 20px 0;
    padding: 0 20px;
    .roleFiles-box {
      width: 100%;
      display: flex;
      padding-left: 22px;
      div {
        line-height: 30px;
      }
      .roleFiles-number {
        width: 200px;
        flex: 0 0 auto;
        text-align: left;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-right: 20px;
      }
      .roleFiles-title {
        width: 500px;
        flex: 1 1 100%;
        text-align: left;
        cursor: pointer;
        position: relative;
        .roleFiles-title-content {
          width: 100%;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          position: relative;
          a {
            width: 100%;
            display: block;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            text-decoration: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: keep-all;
            &:hover {
              color: #8d0101;
            }
            &:active {
              color: #333333;
            }
          }
          &:hover {
            color: #8d0101;
          }
          .roleFiles-title-depart {
            a {
              font-size: 14px;
              color: #999999;
            }
          }
        }

        .roleFiles-childBox {
          padding: 0px 20px;
          display: flex;
          justify-content: flex-start;
          margin-left: -100px;
          .roleFiles-child-number {
            min-width: 130px;
            // padding: 0 10px;
            text-align: left;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            margin-right: 20px;
          }
          .roleFiles-child-title {
            a {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              text-decoration: none;
              text-decoration: none;
              &:hover {
                color: #8d0101;
              }
              &:active {
                color: #333333;
              }
            }
          }
        }
      }
      // .roleFiles-hasChild {
      //   text-align: right;
      //   flex: 1;
      // }
    }
  }
}
.borderBot {
  border-bottom: 1px dashed #212121;
  margin-bottom: 10px;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
  animation-fill-mode: both;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
  animation-fill-mode: both;
}
@keyframes bounce-in {
  0% {
    height: 0;
    opacity: 0;
  }
  100% {
    height: 30px;
    opacity: 1;
  }
}
.red-bold {
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 8px;
    left: 0;
    z-index: 5;
    width: 6px;
    height: 14px;
    background-image: url("./../assets/biaoti@3x.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
  }
}
</style>
